export const REFRESH_MS = 10_000
export const STALE_MS = 60_000

export function createProgressPoller({ fetcher = fetch, getSession, visibility = document, timers = globalThis, onData, onError, onLoading }) {
  let stopped = false
  let active = null
  let interval

  async function refresh() {
    if (stopped || visibility.hidden || active) return
    const request = { controller: new AbortController(), interrupted: false }
    active = request
    onLoading(true)
    let timeout
    try {
      const token = getSession()?.tokens?.accessToken
      if (!token) throw new Error('登录会话已过期，请重新登录后查看开发进度。')
      const deadline = new Promise((_, reject) => {
        timeout = request.timeout = timers.setTimeout(() => {
          request.controller.abort()
          reject(new Error('同步超时（10 秒），请稍后重试。'))
        }, REFRESH_MS)
      })
      const operation = async () => {
        const response = await fetcher('/iam-admin/progress', {
          headers: { Authorization: `Bearer ${token}` },
          cache: 'no-store',
          signal: request.controller.signal,
        })
        if (response.status === 401) throw new Error('登录会话无效或已过期，请重新登录。')
        if (response.status === 403) throw new Error('当前账号没有查看开发进度的权限，请联系管理员。')
        if (response.status === 404 || response.status === 503) throw new Error('开发进度服务尚未配置或暂时不可用。')
        if (!response.ok) throw new Error(`同步失败（HTTP ${response.status}），请稍后重试。`)
        const result = await response.json()
        if (result?.code !== 0 || !result.data || !Array.isArray(result.data.tasks)) {
          throw new Error('进度服务返回的数据不可用，请稍后重试。')
        }
        return result.data
      }
      const data = await Promise.race([operation(), deadline])
      if (!stopped && !request.interrupted) onData(data)
    } catch (error) {
      if (!stopped && !request.interrupted) {
        onError(error instanceof TypeError ? '无法连接进度服务，请检查网络后重试。' : error.message || '同步失败，请稍后重试。')
      }
    } finally {
      timers.clearTimeout(timeout)
      active = null
      if (!stopped) {
        onLoading(false)
        if (request.interrupted && !visibility.hidden) void refresh()
      }
    }
  }

  function onVisibility() {
    if (visibility.hidden) {
      timers.clearInterval(interval)
      interval = undefined
      if (active) {
        active.interrupted = true
        active.controller.abort()
      }
    } else {
      if (!interval) interval = timers.setInterval(refresh, REFRESH_MS)
      void refresh()
    }
  }

  visibility.addEventListener('visibilitychange', onVisibility)
  onVisibility()
  return {
    refresh,
    stop() {
      stopped = true
      timers.clearInterval(interval)
      visibility.removeEventListener('visibilitychange', onVisibility)
      if (active) {
        active.interrupted = true
        timers.clearTimeout(active.timeout)
        active.controller.abort()
      }
    },
  }
}
